import React from "react";
import FilterFind from "../../../components/FilterFind";
import { useNavigate } from "react-router-dom";
import { storage } from "../../../utils/storage";
import FormalLoanCalculationResult from "./FormalLoanCalculationResult";
import InformalLoanCalculationResult from "./InformalLoanCalculationResult";

/**
 * Wrapper: reads calculator result from storage and renders Formal or Informal
 * result table based on loan_model (backend is single source of truth).
 */
const LoanCalculationResult = () => {
  const navigate = useNavigate();
  const stored = storage["localStorage"].get("loan_calculator_result");

  const isInformal =
    stored &&
    typeof stored === "object" &&
    !Array.isArray(stored) &&
    stored.loan_model === "informal";
  const rows = Array.isArray(stored)
    ? stored
    : stored?.rows ?? stored?.data ?? [];

  return (
    <>
      <FilterFind
        back={true}
        backBtn={() => navigate(-1)}
        rightSide={false}
        title="Loan Calculator"
      />
      {isInformal ? (
        <InformalLoanCalculationResult data={stored} />
      ) : (
        <FormalLoanCalculationResult data={rows} />
      )}
    </>
  );
};

export default LoanCalculationResult;
